import { loadOptions } from '../../versa/formset.js';

export default function (...args)
{
	return {
		options: [
			{ value: 'MOV', label: 'Movimentação' },
			{ value: 'RESUP', label: 'Ressuprimento' },
			{ value: 'INV', label: 'Inventário' },
			{ value: 'BLOQ', label: 'Bloqueio' },
			{ value: 'UNPICK', label: 'Unpick' },
			{ value: 'AUDIT_NAO_LOCALIZADO', label: 'Auditoria: produto não localizado' },
			{ value: 'AUDIT_QTD_DIVERGENTE', label: 'Auditoria: quantidade divergente' },
			{ value: 'AUDIT_POSICAO_INCORRETA', label: 'Auditoria: posição incorreta' },
			{ value: 'AUDIT_RESERVA_ORFA', label: 'Auditoria: reserva órfã' },
			{ value: 'AVARIA_FORNECEDOR', label: 'Avaria Fornecedor' },
			{ value: 'AVARIA_ARMAZEM', label: 'Avaria Armazém' },
			{ value: 'AVARIA_TRANSPORTE', label: 'Avaria Transporte' },
			{ value: 'QUARENTENA', label: 'Quarentena' },
			{ value: 'VENCIDO', label: 'Vencidos' },
			{ value: 'VENCIMENTO_CURTO', label: 'Vencimento Curto' },
			{ value: 'FALTA_IBL', label: 'Falta IBL' }
		],
		captureEvents(_this = this)
		{
			loadOptions(this.selector, this.options);
			this.safeProtoCall(_this);
		}
	};
}
